import React from 'react';
import StickyBox from 'react-sticky-box';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import Sidebar from '../Sidebar';
import PlanClassement from './PlanClassement';
import ArchiveFolders from './ArchiveFolders';
import './PlanArchiveTabs.css';

const tabs = [
  { id: 'plans', label: 'Plan de classement', icon: 'ri-git-branch-line', path: '/apps/in/plan-classement' },
  { id: 'folders', label: 'Dossiers d’archive', icon: 'ri-folder-5-line', path: '/apps/in/dossiers-archives' },
];

const PlanArchiveTabs = () => {
  const { pathname } = useLocation();
  const activeTab = pathname === '/apps/in/dossiers-archives' ? 'folders' : 'plans';

  return <>
    <Breadcrumb title="Plan et dossiers d’archive" />
    <div className="content"><div className="container-fluid"><div className="row">
      <div className="col-md-4 col-lg-3 col-xl-3 theiaStickySidebar">
        <StickyBox offsetTop={20} offsetBottom={20}><Sidebar /></StickyBox>
      </div>
      <div className="col-md-8 col-lg-9 col-xl-9">
        <nav className="plan-archive-tabs" aria-label="Organisation des archives">
          {tabs.map((tab) => <Link
            key={tab.id}
            to={tab.path}
            className={`plan-archive-tab ${activeTab === tab.id ? 'is-active' : ''}`}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          ><i className={tab.icon} aria-hidden="true" /> {tab.label}</Link>)}
        </nav>
        <div className="plan-archive-tab-panel">
          {activeTab === 'plans' ? <PlanClassement embedded /> : <ArchiveFolders embedded />}
        </div>
      </div>
    </div></div></div>
  </>;
};

export default PlanArchiveTabs;
